module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['popin', 'popin-question']
  }, [_c('div', {
    class: ['popin-container', _vm.showRecto ? 'recto' : '']
  }, [_c('div', {
    staticClass: "front"
  }, [_c('img', {
    attrs: {
      "src": ("http://transfertsdepekin.fr/assets/questions/" + (_vm.params.characterImg)),
      "alt": _vm.params.character
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popin-question"
  }, [_c('p', {
    staticClass: "popin-question__name"
  }, [_vm._v(_vm._s(_vm.params.character))]), _vm._v(" "), _c('p', {
    staticClass: "popin-question__question",
    domProps: {
      "innerHTML": _vm._s(_vm.params.question)
    }
  }), _vm._v(" "), (_vm.params.type === 'question') ? _c('ul', _vm._l((_vm.params.answers), function(answer, i) {
    return _c('li', {
      attrs: {
        "data-index": i
      },
      domProps: {
        "innerHTML": _vm._s(answer.answer)
      },
      on: {
        "click": _vm.choiceAnswer
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.params.type === 'chance') ? _c('button', {
    staticClass: "popin-question__chance btn",
    on: {
      "click": _vm.chanceResult
    }
  }, [_vm._v("Chance")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('img', {
    attrs: {
      "src": ("http://transfertsdepekin.fr/assets/questions/" + (_vm.params.characterImg)),
      "alt": _vm.params.character
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popin-question"
  }, [_c('p', {
    staticClass: "popin-question__name"
  }, [_vm._v(_vm._s(_vm.params.character))]), _vm._v(" "), (_vm.textResult) ? _c('p', {
    staticClass: "popin-question__award",
    domProps: {
      "innerHTML": _vm._s(_vm.textResult)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.result) ? _c('p', {
    staticClass: "popin-question__result",
    domProps: {
      "innerHTML": _vm._s(_vm.result.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "popin-question__continue btn",
    on: {
      "click": _vm.setPopinState
    }
  }, [_vm._v("\n          Continuer l'aventure\n\n          "), (_vm.params.type === 'chance') ? _c('img', {
    staticClass: "popin-question__cookie",
    attrs: {
      "src": "http://transfertsdepekin.fr/assets/places/chance1.png",
      "alt": "Fortune cookie"
    }
  }) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-065e3aa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popin.vue
// module id = 78
// module chunks = 0